var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 74,
    viewBox: "0 0 69 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.2001V55.5001C1 57.2001 2.4 58.6001 4.1 58.6001H39.7C41.4 58.6001 42.8 57.2001 42.8 55.5001V4.2001C42.8 2.5001 41.4 1.1001 39.7 1.1001H4.1C2.4 1.1001 1 2.5001 1 4.2001Z",
    stroke: "#989898",
    strokeWidth: 1.6382,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8 7.8999H8.20001V12.2999H35.8V7.8999Z",
    fill: "#989898"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 21.3999H8.10001V24.0999H36V21.3999Z",
    fill: "#989898"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 26.6997H8.10001V29.3997H36V26.6997Z",
    fill: "#989898"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 32H8.10001V34.7H36V32Z",
    fill: "#989898"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36 37.3999H8.10001V40.0999H36V37.3999Z",
    fill: "#989898"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9 46.6001H8.10001V49.3001H21.9V46.6001Z",
    fill: "#989898"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 19.1002V70.4002C26.8 72.1002 28.2 73.5002 29.9 73.5002H65.5C67.2 73.5002 68.6 72.1002 68.6 70.4002V19.1002C68.6 17.4002 67.2 16.0002 65.5 16.0002H30C28.2 15.9002 26.8 17.3002 26.8 19.1002Z",
    fill: "#82AA00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8 52.7002C44.5 52.7002 41.9 55.4002 41.9 58.6002C41.9 61.9002 44.6 64.5002 47.8 64.5002C51.1 64.5002 53.7 61.8002 53.7 58.6002C53.7 55.4002 51.1 52.7002 47.8 52.7002ZM48 58.1002C48.8 58.4002 50 58.9002 50 60.2002C50 61.1002 49.3 61.8002 48.3 62.0002V62.9002H47.2V62.0002C46.2 61.8002 45.5 61.1002 45.5 60.2002H46.8C46.8 60.6002 47.3 60.8002 47.7 60.8002C48.1 60.8002 48.6 60.6002 48.6 60.2002C48.6 59.9002 48.3 59.7002 47.4 59.4002C46.6 59.1002 45.4 58.6002 45.4 57.3002C45.4 56.4002 46.1 55.7002 47.1 55.5002V54.6002H48.2V55.5002C49.2 55.7002 49.9 56.4002 49.9 57.3002H48.6C48.6 56.9002 48.1 56.7002 47.7 56.7002C47.3 56.7002 46.8 56.9002 46.8 57.3002C46.9 57.5002 47.2 57.7002 48 58.1002Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7 29.7998H33.8V32.4998H61.7V29.7998Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7 35.0996H33.8V37.7996H61.7V35.0996Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7 40.3999H33.8V43.0999H61.7V40.3999Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/invoices.ae5f8644c648ae1d1ffea5aaf4b953ad.svg";
export { ForwardRef as ReactComponent };